document.addEventListener('scrollreveal:init', (event) => {
    const { sr } = event.detail;
    sr.reveal('.page-title-acf .srFromRight', { origin: 'right', distance: '100px' });
    sr.reveal('.page-title-acf .srFromLeft', { origin: 'left', distance: '100px' });
});